<template>
  <div id="app">
    <div v-if="isLogged">
      <nav-top />
      <side-bar />
      <div class="content-wrapper">
        <div class="content-header">
          <div class="container-fluid">
            <div class="row">
              <!-- <div class="col-sm-6">
                <h1 class="m-0 text-dark">Dashboard</h1>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="#">Home</a></li>
                  <li class="breadcrumb-item active">Dashboard v2</li>
                </ol>
              </div> -->
            </div>
          </div>
        </div>
        <section class="content">
          <div class="container-fluid">
            <router-view/>
          </div>
        </section>
      </div>
    </div>
    <div v-else>
      <login-page />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Menu from './components/General/Menu'
import NavTop from './components/General/NavTop'
import Login from './views/Auth/Login'

export default {
  components: {
    "nav-top": NavTop,
    "side-bar": Menu,
    "login-page": Login
  },
  computed: {
    ...mapGetters({
      isLogged: 'getLoggedState'
    })
  },
}
</script>
